<button
  type="button"
  class="card"
  [class.border-radius-4]="rounded"
  *ngIf="project"
  data-cy="Current cost center"
  (click)="openBillingInfo()"
>
  <div class="content">
    <div class="header">
      <div class="title font-regular">{{ project.description }}</div>
      <ion-icon class="info-icon" name="information-circle-outline"></ion-icon>
    </div>

    <div>{{ getCompanyNameForProject(project, user) }}</div>
    <ion-row class="ion-align-items-center ion-margin-top gap-8">
      <ion-icon name="person"></ion-icon>
      <ion-text>{{ project.role | role: false:isSuperOperatore:buyer:superBuyer | uppercase }}</ion-text>
    </ion-row>
    <ion-row class="ion-align-items-center ion-margin-top gap-8" *ngIf="firstResidualLimit$ | async as firstResidualLimit">
      <ion-icon name="card-outline"></ion-icon>
      <ion-text>{{ firstResidualLimit.labelKey | translate }} &euro;{{ firstResidualLimit.value | number: '1.2-2' }}</ion-text>
    </ion-row>
  </div>
</button>
